export const presetSizes = {
  xsmall: 12,
  small: 16,
  medium: 24,
  large: 48,
  xlarge: 96
};